var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "InputPhoneNumber"
  }, [_c('vue-phone-number-input', {
    attrs: {
      "countries-height": 38,
      "default-country-code": _vm.value === '' ? _vm.lang : '',
      "no-use-browser-locale": _vm.value !== '',
      "translations": _vm.getTranslations
    },
    on: {
      "close": function ($event) {
        _vm.isOptionsOpen = false;
      },
      "phone-number-blur": _vm.checkIsValid,
      "open": function ($event) {
        _vm.isOptionsOpen = true;
      },
      "update": _vm.update
    },
    model: {
      value: _vm.currentValue,
      callback: function ($$v) {
        _vm.currentValue = $$v;
      },
      expression: "currentValue"
    }
  }), _c('span', {
    staticClass: "InputPhoneNumber-iconContainer"
  }, [_c('span', {
    staticClass: "InputPhoneNumber-icon common-chevron-bottom",
    class: _vm.getIsOptionsOpen ? 'InputPhoneNumber-icon--opened' : ''
  })]), _c('transition', {
    attrs: {
      "name": "page",
      "mode": "out-in"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.getCurrentValueNotEmpty,
      expression: "getCurrentValueNotEmpty"
    }],
    staticClass: "InputPhoneNumber-button",
    attrs: {
      "aria-label": _vm.$t('button.clear'),
      "tabindex": _vm.getTabIndexIcon,
      "type": "button"
    },
    on: {
      "click": _vm.clearInputField
    }
  }, [_c('span', {
    staticClass: "InputPhoneNumber-iconClose common-cross"
  })])]), _c('div', {
    staticClass: "InputPhoneNumber-error",
    class: {
      'InputPhoneNumber-error--displayed': _vm.getHasError
    },
    attrs: {
      "aria-label": _vm.$t('inputPhone.error'),
      "tabindex": _vm.getErrorTabIndex
    }
  }, [_vm._v(" " + _vm._s(_vm.getHasError ? _vm.$t('inputPhone.error') : '') + " ")])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }